import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  message,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  MenuUnfoldOutlined,
  AppstoreAddOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import config from "../../util/ApiforContext";
import StockListFilter from "../Filters/StockListTableFilter";
import { ColumnHelper } from "../../util/TableHelper";
import StockAddForm from "../Forms/StockAddForm";
import StockUpdateForm from "../Forms/StockUpdateForm";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import { RowHelper } from "util/TableHelper";
import StockMovementAddForm from "../Forms/StockMovementAddForm";

const StockList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "ÜRÜN LİSTESİ" });
  const [stocks, setStocks] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [dataState, setDataState] = useState([{ skip: 0, take: 20 }]);
  const [currentPage, setCurrentPage] = useState(1);
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [addStockMovementVisibility, setAddStockMovementVisibility] =
    useState(false);
  const [stockId, setStockId] = useState("");

  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setStocks({
      ...stocks,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/Stock?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setStocks({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const onAddStockSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/Stock/GetById/${record.id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const onUpdateStockSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const onAddStockMovementSuccess = () => {
    getTableData();
    setAddStockMovementVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan ürünler güncellenemez.",
    });
  };
  const renderDetailString = (text) => (text ? text : "-");
  const detailColumns = [
    {
      title: "Açıklama",
      dataIndex: "description",
      render: renderDetailString,
    },
    {
      title: "KDV Oranı",
      dataIndex: "vatRate",
      key: "vatRate",
      align: "left",
      render: (data) => {
        return "%" + data;
      },
    },
    {
      title: "Vergisiz Alış Fiyatı",
      dataIndex: "purchasePriceExcTaxesString",
      key: "purchasePriceExcTaxesString",
      align: "left",
    },
    {
      title: "Vergiler Dahil Alış Fiyatı",
      dataIndex: "purchasePriceIncTaxesString",
      key: "purchasePriceIncTaxesString",
      align: "left",
    },
    {
      title: "Vergisiz Satış Fiyatı",
      dataIndex: "sellingPriceExcTaxesString",
      key: "sellingPriceExcTaxesString",
      align: "left",
    },
    {
      title: "Vergiler Dahil Satış Fiyatı",
      dataIndex: "sellingPriceIncTaxesString",
      key: "sellingPriceIncTaxesString",
      align: "left",
    },
  ];
  const columns = [
    {
      title: "Ürün Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.substring(0, 20).length < 20
                ? text.substring(0, 20) + ""
                : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "left",
      render: (text) => {
        return (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text.substring(0, 20).length < 20
                ? text.substring(0, 20) + ""
                : text.substring(0, 20) + "..."}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: "Stok Adedi",
      dataIndex: "count",
      key: "count",
      align: "left",
      render: renderDecimal,
    },
    {
      title: "Stok Birimi",
      dataIndex: "unit",
      key: "unit",
      align: "left",
    },
    {
      title: "Depo No",
      dataIndex: "storageNo",
      render: renderDetailString,
    },
    {
      title: "Raf No",
      dataIndex: "shelfNo",
      render: renderDetailString,
    },
    {
      title: "Palet No",
      dataIndex: "palletNo",
      render: renderDetailString,
    },
    {
      title: "Kap No",
      dataIndex: "containerNo",
      render: renderDetailString,
    },
    {
      title: "İstasyon No",
      dataIndex: "stationNo",
      render: renderDetailString,
    },
    {
      title: "Stok Hareketleri",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "purple", paddingTop: 10 }}
          to={`/stock-movement-history/${record.id}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },
    {
      title: "Fiyat Geçmişi",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "7%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "#A0D911", paddingTop: 10 }}
          to={`/stock-price-history/${record.id}`}
        >
          <MenuUnfoldOutlined />
        </Link>
      ),
    },
    {
      title: "Stok Hareketi Girişi",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "8%",
      render: (text, record) => (
        <Button
          onClick={() => {
            if (record.isActive) {
              setAddStockMovementVisibility(true);
              setStockId(record.id);
            } else {
              openNotificationWithIcon("warning");
            }
          }}
          icon={<AppstoreAddOutlined />}
          type="link"
          style={{ fontSize: "120%", color: "#9254de", paddingTop: 7 }}
        ></Button>
      ),
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        stocks.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setStocks(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.delete(`/Stock/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const exportExcel = () => {
    debugger;
    const hide = message.loading("Excel indiriliyor...", 0);
    const { filter } = tableDataQueryOptions;
    RequestHandler.post(
      `/Stock/ExportExcel`,
      { Query: filter == "" ? "" : "$filter=" + filter },
      false,
      {
        rawResponse: true,
      }
    ).then((res) => {
      debugger;
      if (res.status == 200) {
        window.open(
          `${config.apiUrl}/Stock/DownloadExcelList?fileName=${
            res.data
          }&t=${RequestHandler.getToken()}`
        );
      }
      hide();
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Row justify="end" align="middle" style={{ paddingRight: 16 }}>
            <Tooltip title="Excel İndir">
              <a
                style={{
                  color: "green",
                  fontSize: "180%",
                  marginRight: 30,
                }}
                onClick={exportExcel}
              >
                <FileExcelOutlined />
              </a>
            </Tooltip>
            <Button
              type="primary"
              onClick={() => {
                setAddFormVisibility(true);
              }}
              style={{ marginBottom: 0 }}
            >
              <PlusOutlined /> Ürün Ekle
            </Button>
          </Row>
        </Col>
      </Row>

      <StockListFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            expandable={{
              expandedRowRender: (row) =>
                RowHelper.renderRowDetail({
                  data: row,
                  columns: detailColumns,
                }),
            }}
            onDataStateChange={dataStateChange}
            dataSource={stocks.data}
            loading={stocks.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: stocks.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        id="addStockDrawer"
        title="Ürün Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <StockAddForm onSuccess={onAddStockSuccess} />
      </Drawer>
      <Drawer
        id="updateStockDrawer"
        title="Ürün Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <StockUpdateForm
          data={updateFormData}
          onSuccess={onUpdateStockSuccess}
        />
      </Drawer>

      <Drawer
        id="addStockMovement"
        title="Stok Hareketi Girişi"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddStockMovementVisibility(false)}
        visible={addStockMovementVisibility}
      >
        <StockMovementAddForm
          stockId={stockId}
          onSuccess={onAddStockMovementSuccess}
        />
      </Drawer>
    </>
  );
};

export default StockList;
